import React, { useState } from 'react';
import './App.css';
import nickImage from './assets/Nick.jpg';
import { db } from './firebase';
import { collection, addDoc } from 'firebase/firestore';
import jasmineImage from './assets/JJstrachan.jpg';
import graceImage from './assets/Grace.jpg';

function App() {
  const [formData, setFormData] = useState({
    business: '',
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    service: 'Design',
    comment: '' // ✅ Added comment field
  });

  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await addDoc(collection(db, 'contactSubmissions'), formData);
      setSubmitted(true);
      setFormData({
        business: '',
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        service: 'Design',
        comment: '' // ✅ Reset comment
      });
    } catch (error) {
      console.error('Error submitting form:', error);
    }
  };

  return (
    <div className="App">
      <div id="top"></div>

      <div className="logo-container">
        <img
          src="/vilano-background.png"
          alt="Vilano Consulting Logo"
          className="logo-image"
        />
      </div>

      <div className="logo-tagline-band">
        <p>Engineering and Thermography</p>
      </div>

      <div style={{ height: '30vh' }}></div>

      <div className="content">
        <div className="section" id="about">
          <h2>About Us</h2>
          <p>
            <strong>Vilano Consulting</strong> specializes in electrical engineering services for residential and commercial properties in Florida. The firm was founded by <strong>Nicholas Strachan</strong>, a licensed Professional Engineer in AZ, CA, FL, NC, and NY, and a Certified Level II Thermographer.
          </p>
          <p> Nicholas has over 25 years of experience in engineering design, system evaluations, construction administration, and quality assurance. He has worked on projects throughout the United States and internationally, including residential and commercial developments, research laboratories, universities, museums, cultural centers, and sports venues. </p> 
          <p> His technical knowledge and leadership have supported the delivery of complex, mission-critical projects. In addition to his engineering work, Nicholas provides expert witness testimony and litigation consulting. </p>
          <img
            src={nickImage}
            alt="Nicholas Strachan"
            className="nick-image"
          />
          <p>
            <strong style={{ display: 'block', textAlign: 'center', fontWeight: 500 }}>
              Nicholas Strachan, PE
            </strong>
          </p>
          <img
            src={jasmineImage}
            alt="JJ Strachan"
            className="nick-image"
          />
          <p>
            <strong style={{ display: 'block', textAlign: 'center', fontWeight: 500 }}>
              JJ Strachan, Office Manager
            </strong>
          </p>
          <img
            src={graceImage}
            alt="Grace"
            className="nick-image"
          />
          <p>
            <strong style={{ display: 'block', textAlign: 'center', fontWeight: 500 }}>
              Gracie Strachan, Receptionist
            </strong>
          </p>
        </div>

        <div className="section" id="services">
          <h2>Services</h2>
          <p>Vilano Consulting LLC offers the following services in Florida:</p>

          <p><strong>Electrical Design</strong></p>
          <p>Electrical engineering design services for small to medium-sized commercial projects, including new construction, renovations, tenant improvements, and system upgrades. Our team will collaborate closely with clients, contractors, and permitting authorities to deliver code-compliant, efficient, and constructible designs.</p>

          <p><strong>Expert Services</strong></p>
          <p>We also offer expert witness and litigation consulting services related to electrical failures, construction defects, and insurance claims. These services include:</p>
          <ul>
            <li>Technical Evaluations</li>
            <li>Documentation and Reporting</li>
            <li>Expert Testimony</li>
          </ul>

          <p><strong>Building Recertification Inspections</strong></p>
          <p>Electrical system inspections for 30-, 40-, and 50-year building recertifications, in accordance with jurisdictional requirements. We serve Broward and Miami-Dade Counties, as well as cities in Palm Beach County with similar mandates, such as Boca Raton, Boynton Beach, and Highland Beach. Inspections include infrared thermographic scanning when required to identify potential hazards or system deficiencies. Our reports are prepared to meet jurisdictional submittal standards and include clear recommendations for corrective action when applicable.</p>

          <p><strong>Thermography Inspection Services</strong></p>
          <p>Certified infrared thermography inspections to detect electrical system issues such as overloaded circuits, loose connections, and phase imbalances—often before they lead to failures or unplanned outages. These services support both mandatory recertifications and proactive maintenance programs. All inspections are conducted by a Level II Certified Thermographer using professional-grade infrared imaging equipment, with findings presented in clear, actionable reports.</p>

          <p>
            <strong style={{ display: 'block', textAlign: 'center' }}>
              Contact us for a proposal today!
            </strong>
          </p>
        </div>

        <div className="section" id="contact">
          <h2>Contact Us</h2>
          {submitted ? (
            <p className="submission-success">Thank you for your message. We'll get back to you shortly!</p>
          ) : (
            <form onSubmit={handleSubmit} className="contact-form">
              <label>
                Business/Association:
                <input type="text" name="business" value={formData.business} onChange={handleChange} required />
              </label>
              <label>
                First Name:
                <input type="text" name="firstName" value={formData.firstName} onChange={handleChange} required />
              </label>
              <label>
                Last Name:
                <input type="text" name="lastName" value={formData.lastName} onChange={handleChange} required />
              </label>
              <label>
                Email:
                <input type="email" name="email" value={formData.email} onChange={handleChange} required />
              </label>
              <label>
                Phone Number:
                <input type="tel" name="phone" value={formData.phone} onChange={handleChange} required />
              </label>
              <label>
                Requested Service:
                <select name="service" value={formData.service} onChange={handleChange}>
                  <option value="Design">Design</option>
                  <option value="Expert">Expert Services</option>
                  <option value="Inspection">Building Inspection</option>
                  <option value="Thermography">Thermography Inspection</option>
                </select>
              </label>
              <label>
                Comments:
                <textarea name="comment" value={formData.comment} onChange={handleChange} rows="4" />
              </label>
              <button type="submit">Submit</button>
            </form>
          )}
        </div>
      </div>

      <nav className="nav-bar">
        <a href="#about">About Us</a>
        <a href="#services">Services</a>
        <a href="#contact">Contact</a>
      </nav>

      <div className="footer-info-fixed">
        <p>© 2025 Vilano Consulting LLC</p>
      </div>
    </div>
  );
}

export default App;
